import { Controller } from "@hotwired/stimulus"
import { useRender, html } from "stimulus-lit"
import { FetchResponse } from "types/@hotwired-turbo-7-3-0/http/fetch_response"

export class FormModalController extends Controller<HTMLLinkElement> {
  static values = {
    shouldDisplayModal: Boolean,
    frameId: String,
    label: String,
  }

  declare shouldDisplayModalValue: boolean
  declare readonly frameIdValue: string
  declare readonly labelValue: string

  connect() {
    useRender(this, { container: window.document.body })
  }

  open(event: PointerEvent) {
    if (!event.metaKey) {
      event.preventDefault()
      this.shouldDisplayModalValue = true
    }
  }

  onRequestClose = (event) => {
    if (event.detail.source === "overlay" || event.detail.source === "keyboard") {
      event.preventDefault()
    } else {
      this.shouldDisplayModalValue = false
    }
  }

  closeModalAndReload(event: CustomEvent) {
    const { response } = event.detail.fetchResponse as FetchResponse

    if (event.detail.success && response.redirected) {
      Turbo.visit(response.url, { action: "replace" })
      event.preventDefault()
    }
  }

  render() {
    return html`
      <sl-dialog
        label="${this.labelValue}"
        ?open=${this.shouldDisplayModalValue}
        @sl-request-close=${this.onRequestClose}
        @turbo:submit-end=${this.closeModalAndReload}
      >
        ${this.shouldDisplayModalValue
          ? html`<turbo-frame id="${this.frameIdValue}" src="${this.element.href}"></turbo-frame>`
          : null}
      </sl-dialog>
    `
  }
}
